<template>
  <div class="wrap">
    <header>
      <span class="iconfont icon-back-left" @click="goBack"></span>
      <h2>{{lang.order}}</h2>
    </header>
    <div class="tab">
      <div :class="idxShow==1?'active':''" @click="switchTab(1)">{{lang.pendingOrder}}</div>
      <div :class="idxShow==2?'active':''" @click="switchTab(2)">{{lang.allOrder}}</div>
    </div>
    <div class="pending" v-if="idxShow==1">
      <div>
        <ul>
          <li class="record-list" v-for="e in pdOrds" :key="e.id">
            <div class="pd-hd">
              <div><b>{{e.coinName}}/USDT</b></div>
              <div>{{e.ctime}}</div>
            </div>
            <div class="pd-body">
              <div>{{lang.amount}}: {{currSymbol}}{{e.amt}}</div>
<!--              <div>{{ lang.profit }}: +{{e.odd}}%</div>-->
              <div>{{ lang.lockTime }}: <b>{{e.seconds||0}}s</b></div>
            </div>
            <div class="pd-body">
              <div>{{lang.markedPrice}}: {{e.price}}</div>
<!--              <div>{{lang.buyUpDown}}: {{e.selected?'Call':'Put'}}</div>-->
            </div>
            <div class="pd-body">
              <div>{{ lang.settledPrice }}: {{e.priceJs||'--'}}</div>
              <div>{{lang.investEarnings}}: {{currSymbol}}{{e.earnings||'--'}}</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="no-data" v-if="pdOrds.length == 0">
        <img src="@img/no-data.png" />
        <p>{{ lang.nomore }}</p>
      </div>
    </div>
    <div class="main" v-else>
      <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" ref="loadmore" :auto-fill="false"
        :topPullText="lang.topPullText" :topDropText="lang.dropText" :topLoadingText="lang.loadingText"
        :bottomPullText="lang.bottomPullText" :bottomDropText="lang.dropText" :bottomLoadingText="lang.loadingText">
        <ul>
          <li class="record-list" v-for="item in recordList" :key="item.ordno">
              <p><span><b>{{lang.orderNo}}</b>：{{item.ordno}}</span></p>
              <p><span><b>{{lang.name}}</b>：{{item.coinName}}/USDT</span></p>
              <p><span><b>{{lang.price}}</b>：{{item.price}}</span></p>
              <p><span><b>{{lang.jsPrice}}</b>：{{item.priceJs}}</span></p>
<!--              <p><span><b>{{lang.buyUpDown}}</b>：{{item.selected>0?lang.buyup:lang.buyshort}}</span></p>-->
              <p><span><b>{{lang.lockTime}}</b>：{{item.seconds}}s</span></p>
<!--              <p><span><b>{{lang.profit}}</b>：+{{item.odd}}%</span></p>-->
              <p><span><b>{{lang.amount}}</b>：{{currSymbol}}{{item.amt}}</span></p>
              <p><span><b>{{lang.earnings}}</b>：{{currSymbol}}{{item.bonus || 0}}</span></p>
              <p><span><b>{{lang.orderTime}}</b>：{{item.ctime}}</span></p>
              <p><span><b>{{lang.jsTime}}</b>：{{item.js_time}}</span></p>
              <p>
                <span>
                  <b>{{lang.state}}</b>：
                  <b v-if="item.status == 0 ">{{lang.processing}}</b>
                  <b v-else-if="item.status == 1" class="red">{{lang.fail}}</b>
                  <b v-else-if="item.status == 2" class="green">{{lang.winning}}</b>
                  <b v-else-if="item.status == 3" class="yellow">{{lang.revoke}}</b>
                </span>
              </p>
          </li>
        </ul>
      </mt-loadmore>
<!--      <div class="no-data" v-if="recordList.length==0">-->
<!--        <img src="@img/no-data.png" />-->
<!--        <p>{{lang.nomore}}</p>-->
<!--      </div>-->
    </div>
  </div>
</template>
<script type="text/javascript">
import { CONF } from '@/assets/js/config'
  import {
    mapState
  } from 'vuex'
  export default {
    data() {
      return {
        currSymbol: CONF.CURR_SYMBOL,
        page: 1,
        totalPg: 1,
        recordList: [],
        status:{},
        idxShow:2,
        pdOrds:[],
        ctdTimer:null,
        rltFetching: new Set(),
      }
    },
    created() {
      this.page = 1
      this.idxShow = this.$route.params.idx||2
      this.switchTab(this.idxShow);
    },
    beforeDestroy(){
      clearInterval(this.ctdTimer)
    },
    computed: {
      ...mapState(['userInfo', 'lang'])
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      switchTab(i){
        this.idxShow = i
        this.page = 1;
        clearInterval(this.ctdTimer)
        if (i==1) {
          this.getPdOrd()
        }else{
          this.getRecord();
        }
      },
      getPdOrd(){
        this.$xhrGet('/product/order',{
          page: this.page,
          status:0,
        }).then(res => {
          this.pdOrds = res.data
          this.totalPg = data.totalNum;
          this.ctdTimer = setInterval(() => {
            for (let i = 0; i < this.pdOrds.length; i++) {
              if (this.pdOrds[i].seconds>0) {
                this.pdOrds[i].seconds = this.pdOrds[i].jsAt - parseInt(Date.now()/1000)
                // this.pdOrds[i].seconds = 0
              }
              if (this.pdOrds[i].seconds==0 && this.pdOrds[i].status==0) {
                this.getOrdRlt(this.pdOrds[i])
              }
            }
          }, 1e3);
        }).catch(err=>{
          console.err(err)
        })
      },
      getOrdRlt(o){
        if (this.rltFetching.has(o.id)) return
        this.rltFetching.add(o.id)
        this.$doRequest('post', '/prod/betResult', {oid: o.id}).then(res => {
          let ld = res.data.data
          o.priceJs = ld.priceJs
          o.earnings = ld.bonus
          o.status = ld.status
          this.rltFetching.delete(o.id)
        }).catch(err=>{
          this.rltFetching.delete(o.id)
        })
      },
      getRecord() {
        this.$indicator.open(this.lang.loading);
        this.$xhrGet('/product/order', {
            page: this.page
          })
          .then(res => {
            this.$indicator.close();
            if (res.err == 0) {
              let data = res.data;
              if (this.page>1) {
                this.recordList = this.recordList.concat(data)
              } else {
                this.recordList = data;
              }
              this.totalPg = data.totalNum;
              this.status = data.status;
            }else if (res.err == 200 || res.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      },
      loadTop() {
        //下拉刷新
        this.page = 1;
        this.getRecord();
        this.$refs.loadmore.onTopLoaded();
      },
      loadBottom() {
        this.page++;
        if (this.page <= this.totalPg) {
          this.getRecord();
        }
        this.$refs.loadmore.onBottomLoaded();
      },
    }
  }
</script>
<style type="text/css"  scoped>
  .tab {
    display: flex;
    justify-content: space-around;
    padding: 10px 12px 0 12px;
    div{
      flex: 1;
      text-align: center;
      padding-bottom: 10px;
    }
    .active{
      border-bottom: 2px solid #34c7fe;
      font-weight: 800;
    }
  }
  .pending{
    .pd-hd{
      display: flex;
      justify-content: space-between;
      margin-bottom: 4px;
      padding-bottom: 6px;
      border-bottom: 1px solid #DDD;
    }
    .pd-body{
      display: flex;
      justify-content: space-between;
      +div{
        padding-top: 6px;
      }
    }
  }
  .record-list {
    margin: 12px;
    padding: 12px;
    border-radius: 10px;
    background: rgba(139, 152, 244, .1);

    p {
      display: flex;
      justify-content: space-between;
      line-height: 24px;
      color: #666;

      b {
        color: #333;
      }

      .title {
        color: #000;
        font-size: 15px;
        font-weight: bold;
      }

      .red {
        color: rgb(231, 76, 60);
      }

      .green {
        color: green;
      }

      .yellow {
        color: #ffb115;
      }
    }
  }

  .no-data {
    height: 400px;
  }
</style>